import styled from 'styled-components'
import { BaseMaskedInput } from 'components/Inputs/Base'

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
`

/* O número não passa por baixo do logo da bandeira. */
export const MaskedInput = styled(BaseMaskedInput)`
  padding-right: 56px;
`

export const Image = styled.img`
  position: absolute;
  right: 14px;
  width: 34px;
  height: 22px;
`
